import React from 'react';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/metaPixel';
export function StickyMobileCTA() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white p-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] sm:hidden" data-id="element-187" data-mp="1jr2955axsran">
      <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="flex w-full items-center justify-center rounded-lg bg-coral py-4 text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-coral-dark" data-id="element-188" data-mp="1opnbba9r1l1q">
        Quiero el método antiinflamatorio
      </a>
    </div>;
}